import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { SearchInput } from '@gem/ui-kit';

import { ParticipantList } from './ParticipantList/ParticipantList';
import { useParticipantsPopupPresenter } from './ParticipantsPopup.presenter';
import styles from './ParticipantsPopup.styles.m.css';
import type { IParticipantsPopupParams } from './ParticipantsPopup.types';

export const ParticipantsPopup: FC<ICommonPopupsProps<IParticipantsPopupParams>> = observer(
  (props) => {
    const { popupInstance } = props;

    const { t } = useTranslation();

    const presenter = useParticipantsPopupPresenter(props);

    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={presenter.title}
        isOpened={!!presenter.group}
        isHidden={popupInstance.isHidden}
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <SearchInput
          className={styles.search}
          placeholder={t('search_hint')}
          value={presenter.searchText}
          onChange={presenter.onSearch}
        />

        <ParticipantList
          group={presenter.group}
          searchText={presenter.searchText}
          onAddParticipantClick={presenter.onAddParticipantClick}
          onParticipantClick={presenter.onParticipantClick}
        />
      </Popup>
    );
  }
);
